import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PopupTransactionEmailComponent} from './popup-transaction-email/popup-transaction-email.component';
import {TableDataModule} from '../../components/table-data/table-data.module';
import {ToastModule} from 'primeng/toast';
import {TabViewModule} from 'primeng/tabview';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ComponentsModule} from '../../components/components.module';
import {FormsModule} from '@angular/forms';
import {MessageModule} from 'primeng/message';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { AccordionModule } from "primeng/accordion";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

const cmp = [PopupTransactionEmailComponent];

@NgModule({
    declarations: [
        ...cmp],
    imports: [
    CommonModule,
    FormsModule,
    TableDataModule,
    ToastModule,
    TabViewModule,
    ButtonModule,
    TooltipModule,
    OverlayPanelModule,
    ComponentsModule,
    MessageModule,
    ProgressSpinnerModule,
    AccordionModule,
    TranslateModule.forChild({
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslateHttpLoader,
                },
                isolate: false,
            }),
],
    exports: [...cmp]
})
export class PopupModule {
}
